import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import { serviceData } from '../data/services';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './ServicePage.css';
import ContactSection from "../components/ContactSection";

export default function ServicePage() {
  const { slug } = useParams();
  const service = serviceData[slug];
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!service) {
    return (
      <>
        <Navbar />
        <section className="service-page not-found-page">
          <div className="service-not-found-card">
            <p className="service-badge">Page introuvable</p>
            <h2>Service non trouvé</h2>
            <p>
              Le service que tu recherches n’existe pas ou n’est plus disponible.
            </p>
            <Link to="/" className="back-home-btn">
              Retour à l’accueil
            </Link>
          </div>
        </section>
        <Footer />
      </>
    );
  }

  const goToPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? service.images.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === service.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <>
      <Navbar />

      <section className="service-page">
        <div className="service-hero">
          <div className="service-hero-overlay"></div>

          <div className="service-hero-content">
            <p className="service-badge">Kyra Renov • Service</p>

            <h1>{service.title}</h1>

            <div className="breadcrumb">
              <Link to="/" className="breadcrumb-link">Accueil</Link>
              <span className="breadcrumb-separator">›</span>
              <Link to="/#services" className="breadcrumb-link">Services</Link>
              <span className="breadcrumb-separator">›</span>
              <span className="breadcrumb-current">{service.title}</span>
            </div>
          </div>
        </div>

        <div className="service-content-wrapper">
          <div className="service-gallery-card">
            <div className="carousel-wrapper">
              <button className="carousel-arrow left" onClick={goToPrev} type="button">
                &#10094;
              </button>

              <div className="carousel-main">
                <div className="carousel-thumbnails">
                  {service.images.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`${service.title} ${index + 1}`}
                      className={`thumbnail ${index === currentIndex ? 'active' : ''}`}
                      onClick={() => setCurrentIndex(index)}
                    />
                  ))}
                </div>

                <div className="carousel-image-container">
                  <img
                    src={service.images[currentIndex]}
                    alt={service.title}
                    className="carousel-image"
                  />
                </div>
              </div>

              <button className="carousel-arrow right" onClick={goToNext} type="button">
                &#10095;
              </button>
            </div>
          </div>

          <div className="service-description-card">
            <div className="service-description-header">
              <p className="service-mini-badge">Détails du service</p>
              <h2>Un accompagnement soigné pour votre projet</h2>
            </div>

            <div className="service-description">
              {service.description.split('\n').map((block, i) => {
                const trimmedBlock = block.trim();

                if (!trimmedBlock) return null;

                if (trimmedBlock.startsWith('##')) {
                  return (
                    <h3 key={i}>
                      {trimmedBlock.replace('##', '').trim()}
                    </h3>
                  );
                }

                if (trimmedBlock.includes('**')) {
                  const boldText = trimmedBlock.match(/\*\*(.*?)\*\*/g);
                  let formattedText = trimmedBlock;

                  if (boldText) {
                    boldText.forEach((bold) => {
                      const clean = bold.replace(/\*\*/g, '');
                      formattedText = formattedText.replace(
                        bold,
                        `<strong>${clean}</strong>`
                      );
                    });
                  }

                  return (
                    <p key={i} dangerouslySetInnerHTML={{ __html: formattedText }}></p>
                  );
                }

                return <p key={i}>{trimmedBlock}</p>;
              })}
            </div>
          </div>
        </div>
      </section>

      <ContactSection />
      <Footer />
    </>
  );
}